import { render, staticRenderFns } from "./TTabView.vue?vue&type=template&id=54e0cb5e&scoped=true&"
import script from "./TTabView.vue?vue&type=script&lang=js&"
export * from "./TTabView.vue?vue&type=script&lang=js&"
import style0 from "./TTabView.vue?vue&type=style&index=0&id=54e0cb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0cb5e",
  null
  
)

export default component.exports